import BackendAPI from '../api/BackendAPI';
import config from '../config';
import qs from 'query-string';

export class OffersService extends BackendAPI {
    constructor() {
        super();
        this.serverPath = config.coreApiUrl;
    }

    customize(requestedAmount) {
        const url = `${this.serverPath}v2/offers/customize`;
        return this.request('PUT', url, { requestedAmount });
    }

    customizeAuthenticated(requestedAmount, loanId) {
        const url = `${this.serverPath}v1/loans/${loanId}`;
        return this.request('PUT', url, { requestedAmount });
    }

    getLoanOffers(queryParams, loanId) {
        const stringified = qs.stringify(queryParams);
        const queryString = stringified ? '?' + stringified : '';
        const url = `${this.serverPath}v1/loans/${loanId}/loanOffers${queryString}`;
        return this.request('POST', url);
    }

    get(queryParams = {}) {
        const stringified = qs.stringify(queryParams);
        const queryString = stringified ? '?' + stringified : '';
        const url = `${this.serverPath}v2/offers${queryString}`;
        return this.request('GET', url);
    }

    select({ offerId, deviceFingerprint, partnerExternalReference, partnerCustomerId }) {
        const url = `${this.serverPath}v2/offers/${offerId}`;
        return this.request('POST', url, { 
            deviceFingerprint, 
            partnerExternalReference, 
            partnerCustomerId 
        });
    }

    selectAuthenticated({ offerId, loanId }) {
        const url = `${this.serverPath}v1/loans/${loanId}/chooseLoan`;
        return this.request('POST', url,  { loanOfferId: offerId });
    }
}
